import { Box, Button, Card, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HomePageContainer = styled(Box)(() => ({
	display: 'grid',
	gridTemplateColumns: 'repeat(2, 1fr)',
	gap: '32px',
	padding: '32px',
	backgroundColor: '#F5F5F5',
}));

export const Section = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
}));

export const SectionHeader = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'flex-start',
	gap: '16px',
}));

export const SectionHeading = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
}));

export const AddButton = styled(Button)(({ theme }) => ({
	fontWeight: 600,
	textTransform: 'none',
	borderRadius: theme.shape.borderRadius,
	paddingLeft: theme.spacing(2.5),
	paddingRight: theme.spacing(2.5),
	boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
	flexShrink: 0,
	'&:hover': {
		boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
	},
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
	fontSize: '24px',
	fontWeight: 700,
	color: theme.palette.text.primary,
}));

export const SectionSubtitle = styled(Typography)(({ theme }) => ({
	fontSize: '14px',
	fontWeight: 400,
	color: theme.palette.text.secondary,
}));

export const AnnouncementHeader = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'flex-start',
	justifyContent: 'space-between',
	gap: '8px',
}));

export const EntryActions = styled(Box)(() => ({
	display: 'flex',
	gap: '4px',
	marginLeft: 'auto',
	flexShrink: 0,
}));

export const ActionButton = styled(IconButton)(({ theme }) => ({
	width: 32,
	height: 32,
	color: theme.palette.text.secondary,
	'&:hover': {
		backgroundColor: theme.palette.action.hover,
		color: theme.palette.text.primary,
	},
}));

export const AnnouncementCard = styled(Card)(() => ({
	padding: '24px',
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
	borderRadius: '12px',
	position: 'relative',
}));

export const AnnouncementTitle = styled(Typography)(() => ({
	fontSize: '16px',
	fontWeight: 600,
	color: '#1A1A1A',
}));

export const AnnouncementDate = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: 400,
	color: '#666666',
	marginTop: '4px',
}));

export const AnnouncementDescription = styled(Typography)(() => ({
	fontSize: '14px',
	fontWeight: 400,
	color: '#333333',
}));

export const CalendarContainer = styled(Card)(() => ({
	padding: '24px',
	boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
	borderRadius: '12px',
}));

export const EventCard = styled(Card)(() => ({
	padding: '16px',
	display: 'flex',
	gap: '16px',
	alignItems: 'center',
	boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
	borderRadius: '12px',
	border: '1px solid #E0E0E0',
}));

export const EventDate = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: '#4355AB',
	borderRadius: '8px',
	padding: '12px 16px',
	minWidth: '60px',
}));

export const EventDay = styled(Typography)(() => ({
	fontSize: '24px',
	fontWeight: 700,
	color: '#FFFFFF',
	lineHeight: 1,
}));

export const EventMonth = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: 600,
	color: '#FFFFFF',
	textTransform: 'uppercase',
}));

export const EventInfo = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
	flex: 1,
}));

export const EventTitle = styled(Typography)(() => ({
	fontSize: '16px',
	fontWeight: 600,
	color: '#1A1A1A',
}));

export const EventDescription = styled(Typography)(() => ({
	fontSize: '14px',
	fontWeight: 400,
	color: '#666666',
}));
